import { apiFetch } from "./client";

export type TotpStatus = { enabled: boolean };
export type TotpSetup = { secretBase32: string; provisioningUri: string };
export type TotpConfirm = { enabled: boolean; recoveryCodes: string[] };

export const totpApi = {
  status: () => apiFetch<TotpStatus>("/me/totp/status"),
  setup: () => apiFetch<TotpSetup>("/me/totp/setup", { method: "POST" }),
  confirm: (code: string) =>
    apiFetch<TotpConfirm>("/me/totp/confirm", { method: "POST", body: { code } }),
  // Both take a current authenticator code: each one on its own defeats the
  // second factor (fresh plaintext recovery codes / 2FA switched off), so a live
  // session alone is not enough to authorise them.
  regenerateRecoveryCodes: (code: string) =>
    apiFetch<{ recoveryCodes: string[] }>("/me/totp/recovery-codes", { method: "POST", body: { code } }),
  disable: (code: string) =>
    apiFetch<TotpStatus>("/me/totp/disable", { method: "POST", body: { code } }),
};
